<script>
  import ScatterPlot from "lib/components/ScatterPlot.svelte";
  import { pmfilters } from "lib/stores.js";
  import { SectionWrapper } from "paxray-components-svelte";
  import Header from "lib/components/Header.svelte";
  // import PMFilter from "./pmfilter/Filter.svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  export let analysisid;

  let dottetChart = [];

  $: {
    fetchWithSession(
      `/api/analysis/cases/getDottetChart/${analysisid}?filter=${JSON.stringify($pmfilters[analysisid])}`,
    )
      .then((response) => response.json())
      .then((data) => {
        dottetChart = data;
      });
  }
</script>

<Header section="Object" breadcrumb="Macro View">
  <!-- <PMFilter /> -->
</Header>
<SectionWrapper fullscreen={true}>
  <ScatterPlot data={dottetChart} slot="main" isMacro={true} />
</SectionWrapper>
